import CommonLayout from "../layouts/CommonLayout";
import DiagnosticDashboard from "../layouts/Diagnostic/DiagnosticDashboard";
import DiagnosticTests from "../layouts/Diagnostic/DiagnosticTests";
import DiagnosticProfileSettings from "../layouts/Diagnostic/DiagnosticProfileSettings";
import DiagnosticAppointments from "../layouts/Diagnostic/DiagnosticAppointments";
import DiagnosticPatients from "../layouts/Diagnostic/DiagnosticPatients";
import DiagnosticReports from "../layouts/Diagnostic/DiagnosticReports";
import DiagnosticNotifications from "../layouts/Diagnostic/DiagnosticNotifications";
import AdminProtectedRoute from "../ProtectedRoute";

const diagnosticRoutes = [
    { path: "/diagnostic/dashboard", element: <AdminProtectedRoute><CommonLayout><DiagnosticDashboard /></CommonLayout></AdminProtectedRoute> },
    { path: "/diagnostic/tests", element: <AdminProtectedRoute><CommonLayout><DiagnosticTests /></CommonLayout></AdminProtectedRoute> },
    { path: "/diagnostic/appointments", element: <AdminProtectedRoute><CommonLayout><DiagnosticAppointments /></CommonLayout></AdminProtectedRoute> },
    { path: "/diagnostic/patients", element: <AdminProtectedRoute><CommonLayout><DiagnosticPatients /></CommonLayout></AdminProtectedRoute> },
    { path: "/diagnostic/reports", element: <AdminProtectedRoute><CommonLayout><DiagnosticReports /></CommonLayout></AdminProtectedRoute> },
    { path: "/diagnostic/notifications", element: <AdminProtectedRoute><CommonLayout><DiagnosticNotifications /></CommonLayout></AdminProtectedRoute> },
    { path: "/diagnostic/profile", element: <AdminProtectedRoute><CommonLayout><DiagnosticProfileSettings /></CommonLayout></AdminProtectedRoute> },
];

export default diagnosticRoutes;

